import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-college-print',
  templateUrl: './college-print.component.html',
  styleUrls: ['./college-print.component.scss']
})
export class CollegePrintComponent implements OnInit {
  APIService: string;
  CollegePrintForm: FormGroup;
  DsCodelist: any;
  filteredListDistCode: any;
  districtSelect = true;
  Table = false;
  tncodelist: any;
  filteredListTownCode: any;
  GridData: any[];
  SessionNo: any;
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,
    public router: Router,
    private httpClient: HttpClient,
    private spinner: NgxSpinnerService,
    public dialogRef2: MatDialogRef<CollegePrintComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }

    this.districtSelect = true;
    this.Table = false;
    this.CollegePrintForm = this.fb.group({
      CgCode: new FormControl(''),
      CgName: new FormControl(''),
      DsCode: new FormControl(''),
      TnCode: new FormControl(''),
      CgCent: new FormControl(''),
      CgOnlyCent: new FormControl(''),
      CgType: new FormControl(''),
      HslcAhm: new FormControl(''),
      WithAddr: new FormControl('')
    });

    this.fetchDistrict();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  fetchDistrict() {
    const payload = {};
    this.umsService.getDistrict(payload).subscribe((res) => {
      if (res.status) {
        this.DsCodelist = res.data;
        this.filteredListDistCode = this.DsCodelist.slice();
      }
    });
  }

  SelectTn(dsCode){
    const payload = {};
    payload['TnDsCode'] = dsCode;
    this.umsService.getTown(payload).subscribe((res) => {
      if (res.status) {
        this.districtSelect = false
        this.tncodelist = res.data;
        this.filteredListTownCode = this.tncodelist.slice();
      }
    });
  }

  Print(){
    let submitpayload = this.CollegePrintForm.value;
    let payload1 = {}
    payload1['Ds'] = submitpayload['DsCode'],
    payload1['Tn'] = submitpayload['TnCode'],
    payload1['Type'] = submitpayload['CgType'],
    payload1['Cent'] = submitpayload['CgCent'],
    payload1['OnlyCent'] = submitpayload['CgOnlyCent'],
    payload1['WithAddr'] = submitpayload['WithAddr'],
    payload1['MenuName'] ='Master-College';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 107,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
    this.dialogRef2.close()
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  List(){
    this.GridData = []
    this.Table = false
    this.spinner.show();
    const payload = this.CollegePrintForm.value;
    this.umsService.SearchCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.Table = true;
      this.GridData = res.data
    
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.Table = false;
      this.GridData = []
    })
  }
}
